import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT, NAV_LINKS } from "../lib/site";

export const Footer = () => (
  <footer className="border-t border-ivory/10 bg-[#141414] text-ivory" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-20 lg:px-8">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo className="h-14" />
          <p className="mt-6 max-w-md text-sm leading-relaxed text-ivory/60">
            PNG Landed Excellence is a premier landed curation and marketing team within PropNex Realty —
            Singapore's largest listed real estate agency. This site is a complimentary design preview.
          </p>
          <div className="mt-6 space-y-1 text-xs text-ivory/50" data-testid="footer-cea-disclosure">
            <p>{CONTACT.agent} · {CONTACT.role}</p>
            <p>CEA Reg. No. {CONTACT.ceaReg}</p>
            <p>{CONTACT.agency} · CEA Licence No. {CONTACT.agencyLicence}</p>
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="eyebrow text-ivory/70">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.to + l.hash}
                  className="text-sm text-ivory/70 transition-colors duration-300 hover:text-ivory"
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="eyebrow text-ivory/70">Contact Andy</p>
          <ul className="mt-5 space-y-4 text-sm">
            <li>
              <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="group flex items-center gap-3 text-ivory/80 transition-colors hover:text-ivory">
                <Phone className="h-4 w-4 text-ivory/60" /> {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="group flex items-center gap-3 text-ivory/80 transition-colors hover:text-ivory">
                <MessageCircle className="h-4 w-4 text-ivory/60" /> WhatsApp Andy
                <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="group flex items-center gap-3 text-ivory/80 transition-colors hover:text-ivory">
                <Mail className="h-4 w-4 text-ivory/60" /> {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 border-t border-ivory/10 pt-8">
        <p className="text-[0.7rem] leading-relaxed text-ivory/40" data-testid="footer-preview-notice">
          Design proposal notice: this is a standalone demonstration preview created for Andy Cheng and PNG Landed
          Excellence. It is not an official PropNex corporate website, and it does not modify or replace the live
          pnglandedexcellence.com site. All property listings, prices and articles shown are clearly-labelled sample
          records for layout demonstration only. Production deployment on Wix, together with live listings, CMS
          wiring and IRAS-verified calculations, must be configured separately.
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
          <p className="text-xs text-ivory/40">© 2026 PNG Landed Excellence · Concept preview</p>
          <p className="text-xs uppercase tracking-[0.25em] text-ivory/40">Exceptional Landed Homes · Expertly Curated</p>
        </div>
      </div>
    </div>
  </footer>
);
